import { isEqual } from 'lodash';
import { IFilterComparator, RangeFilterModel } from '../../filter-types';

export class RangeModelComparator
  implements IFilterComparator<RangeFilterModel> {
  applyFilterOptions() {
    // do nothing
  }

  hasValidDiff(
    grid: Partial<RangeFilterModel>,
    store: RangeFilterModel
  ): boolean {
    if (!grid) {
      return true;
    }
    return !(
      isEqual(grid.minValue, store.minValue) &&
      isEqual(grid.maxValue, store.maxValue) &&
      isEqual(grid.isFilterActive, store.isFilterActive)
    );
  }
}
